import React, { useRef } from 'react';
import './FirstChat.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpFromBracket, faFilePdf, faLock } from '@fortawesome/free-solid-svg-icons';
import FileInput from '../FileInput/FileInput';

const FirstChat = ({ onFileSelect, onFileRemove, onUpload, userEmail }) => {
    const fileInputRef = useRef();

    return (
        <section className="first-chat">
            <div className="first-chat-heading">
                <span className="first-chat-icon"><FontAwesomeIcon icon={faFilePdf} /></span>
                <div>
                    <span className="first-chat-eyebrow">Nova análise</span>
                    <h1>Abra um documento para conversar.</h1>
                    <p>Envie um PDF jurídico para gerar um índice privado e iniciar a leitura assistida.</p>
                </div>
            </div>

            <button
                className="first-chat-dropzone"
                onClick={() => fileInputRef.current?.onChooseFile()}
                type="button"
            >
                <FontAwesomeIcon icon={faArrowUpFromBracket} />
                <strong>Selecionar documento PDF</strong>
                <span>Até 50 MB</span>
            </button>

            <FileInput
                ref={fileInputRef}
                onFileSelect={onFileSelect}
                onFileRemove={onFileRemove}
                onUpload={onUpload}
                userEmail={userEmail}
            />

            <p className="first-chat-privacy">
                <FontAwesomeIcon icon={faLock} />
                O documento permanece associado somente à sua análise.
            </p>
        </section>
    );
};

export default FirstChat;
